// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q2/2022technology/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (workType: number, page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType,
      page,
      search,
    },
  });
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getRules = (id: number) => {
  const data: { [key: number]: string } = {
    1: `<p>为深入贯彻习近平总书记在人才工作会议上的重要指示精神，积极响应重庆市委、市政府关于科技创新和人才工作方针政策，贯彻落实《2022重庆市人民政府工作报告》中提出的更大力度推动科技创新，加快建设具有全国影响力的科技创新中心，大力弘扬科学家精神，2022年重庆日报报业集团将继续举办“十大重庆科技创新年度人物评选”活动。通过评选活动的持续开展，为全市科技创新工作积蓄更多创新要素、激发更多创新动能、集聚更多创新人才，为建设具有全国影响力的科技创新中心、推进成渝双城经济圈建设和发展贡献更大力量。</p>`,
    2: `<h4>一、指导单位</h4>
<p>中共重庆市委宣传部</p>
<h4>二、支持单位</h4>
<p>重庆市科学技术协会、西部科学城重庆高新区管委会</p>
<h4>三、主办单位</h4>
<p>重庆日报报业集团</p>
<h4>四、承办单位</h4>
<p>上游新闻</p>
<h4>五、数据支持单位</h4>
<p>天眼查</p>
<h4>六、协办单位</h4>
<p>重庆高新区科协、重庆市科技创新“N次方”传播联盟、5G应用产业方阵重庆分联盟、重庆市物联网产业协会、重庆市新材料产业联合会</p>
<h4>七、媒体单位</h4>
<p>重庆日报、上游新闻、重庆电视台、重庆晨报、重庆晚报、重庆商报、重庆科技报等。</p>`,
    3: `<p><span style='font-weight:600'>一、2022十大重庆科技创新年度人物</span></p>
<p><span style='font-weight:600'>二、2022十大重庆科技创新年度企业家</span></p>
<p><span style='font-weight:600'>三、2022西部（重庆）科学城十大科技创新事件</span></p>`,
    4: `<p>凡为重庆市科技创新和经济社会发展做出突出贡献的专业技术人才、高技能人才、企业经营管理人才等均可参评“2022十大重庆科技创新年度人物”及“2022十大重庆科技创新年度企业家”。</p>
        <p>凡为所属地在西部（重庆）科学城辖区内，以“坚持面向世界科技前沿、面向经济主战场、面向国家重大需求、面向人民生命健康”为原则，通过科技研发、技术创新对区域科技创新、经济社会发展起到突出支撑和引领作用，在全市、全国乃至国际上产生重要影响力的科技项目、科技成果、科技活动、前沿技术和创新产品等，均可参评“2022西部（重庆）科学城十大科技创新事件”。</p>
        <p>&nbsp;&nbsp;<span style='font-weight:600'>一、2022十大重庆科技创新年度人物</span></p>
        <p>&nbsp;&nbsp;1.坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。</p>
<p>&nbsp;&nbsp;2.遵守宪法和法律。</p>
<p>&nbsp;&nbsp;3.具有良好的职业道德，诚实守信、爱岗敬业、学风严谨、为人正派，在本领域（行业）具有良好声誉，近三年没有严重违法违规行为。</p>
<p>&nbsp;&nbsp;4.在2021年度实现重要科技创新成果，形成社会影响力，符合下列条件之一：</p>
<p>（1）重大科学研究。完成重要科学技术研究，引领科技创新项目的研发突破，对社会发展的关键科学问题提供较好的解决方案。</p>
<p>（2）关键技术突破。重视科技创新，通过对技术产品的开发、应用、推广，实现关键技术突破，促进科学技术的对外开放与应用合作。</p>
<p>（3）重大成果转化。实现科学技术成果转化，并将转化成果推广到市场并产生较好的市场效益。</p>
<p>（4）显著社会效应。为社会公共服务提供高质量科普产品并产生积极社会效应。</p>
<p>&nbsp;&nbsp;<span style='font-weight:600'>二、2022十大重庆科技创新企业家</span></p>
<p>&nbsp;&nbsp;1.坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。</p>
<p>&nbsp;&nbsp;2.遵守宪法和法律。</p>
<p>&nbsp;&nbsp;3.具有良好的职业道德，诚实守信、爱岗敬业、学风严谨、为人正派，在本领域（行业）具有良好声誉，近三年没有严重违法违规行为。</p>
<p>&nbsp;&nbsp;4.在2021年度以科技创新带动企业发展，并发挥积极的行业引领作用，创造了突出的经济效益和社会效益，符合下列条件之一：</p>
<p>（1）强劲经济表现。所在企业在行业中，拥有领先的市场地位、经济表现优异。</p>
<p>（2）创新核心技术。所带领企业拥有较强的创新能力，在自主研发或推广新技术等方面有较好成效。</p>
<p>（3）优质人才团队。积极引进和培养科技创新领域专业人才，拥有一支强有力的科技创新人才队伍。</p>
<p>（4）深远公众影响。参评人具有公众影响力、知名度、诚信度，积极关注并支持社会公益事业建设。</p>
<p>&nbsp;&nbsp;<span style='font-weight:600'>三、2022西部（重庆）科学城十大科技创新事件</span></p>
<p>&nbsp;&nbsp;1.参评对象所属权须为工商、税务注册登记在西部（重庆）科学城范围内的企业、高校、科研院所或其他实体机构，在本领域（行业）具有良好声誉，近三年没有严重违法违规行为。</p>
<p>&nbsp;&nbsp;2.参评对象所属领域主要聚焦新一代信息技术、生命健康、绿色低碳及智能制造、高技术服务四大产业。</p>
<p>&nbsp;&nbsp;3.参评对象的研发方向、技术成果和创新产品在科技创新领域具有重要突破，在全市、全国或者国际上有重大影响，对西部（重庆）科学城的科技创新和经济发展能起到积极的支撑和推动作用，且符合下列条件之一：</p>
<p>（1）关键技术突破。具有突破关键“卡脖子”技术的科研基础和能力，或在前沿科技研发创新方面，具有较强的行业牵引性和示范性。</p>
<p>（2）知识产权明晰。具有核心知识产权，无知识产权纠纷。基础研究具备原创性、探索性和创新性。其中，原创性的研究成果转化为原创性的技术，为科技进步和产业转型升级提供核心动力和技术支撑。</p>
<p>（3）高端人才领衔。所属团队拥有多名科技创新领域的高层次人才或领军人才，研发能力强，合作协同度高。</p>
<p>（4）广阔市场前景。研发成果已投入或即将投入市场，应用场景广泛，商业模式创新，具备一定的市场发展潜力或已产生较为显著的经济效益。</p>`,
    5: `<h4>一、启动报名（即日起至6月中旬）</h4>
    <p>启动评选工作，上游新闻以报刊、网络等形式广泛宣传评选活动。动员号召广大参评对象积极参与，接收、汇总、整理参评对象申报材料，对申报材料进行合规性初审。</p>
    <h4>二、审查走访（6月-7月）</h4>
    <p>书面征求市级相关部门意见，对报名参评人员进行政治资格审查，同步采取实地走访等形式对参评人员申报材料真实性、合规性等进行核查。</p>
    <h4>三、初筛入围（6月-7月）</h4>
    <p>依据政治审查和实地走访等情况，确定网络投票环节入围人选。</p>
    <h4>四、网络投票（7月上旬）</h4>
    <p>在互联网展示入围人选基本情况，面向全社会开展投票活动。</p>
    <h4>五、综合评审（7月中旬）</h4>
    <p>邀请市级相关部门领导和科技领域专家学者等共同组成评委会进行现场综合评审，产生拟发布榜单。</p>
    <h4>六、名单公示（7月下旬）</h4>
    <p>对评委会评审产生的拟发布榜单进行全媒体公示，并广泛接受相关部门及社会大众的监督。</p>
    <h4>七、榜单发布（7月-8月）</h4>
    <p>在西部（重庆）科学城召开榜单发布典礼，通过各类媒体以电视、广播、网络、报刊、新媒体等全媒体形式充分展示重庆科技创新顶尖实力，营造重庆科技创新良好氛围，助力西部科技创新中心建设。</p>
    <p>备注：具体时间以组委会通知为准。</p>
    `,
    6: `<h4>报名表下载：</h4>
    <p><a download="2022十大重庆科技创新年度人物报名表" href="https://testimage.cqcb.com/webupload/o_1g17hpsdi16hj11281k54vml3bs7.docx">
    2022十大重庆科技创新年度人物报名表
    </a></p>
    <p><a download="2022十大重庆科技创新企业家报名表" href="https://testimage.cqcb.com/webupload/o_1g17hs6j2gdkbjc18pd1r501ta7.docx">
    2022十大重庆科技创新企业家报名表
    </a></p>
    <p><a download="2022西部（重庆科学城）十大科技创新事件报名表" href="https://testimage.cqcb.com/webupload/o_1g17htbs11uj4so61o5d9hi18dr7.docx">
    2022西部（重庆科学城）十大科技创新事件报名表
    </a></p>
    <h4>报名咨询电话：</h4>
    <p>王老师15123398085（微信同号）</p>
    <h4>报名材料上传邮箱：</h4>
    <p>463393220@qq.com</p>`,
  };
  return data[id];
};
export { getBaseInfo, getVoteList, getDetail, getRules, getNews };
